import { useState } from "react";
import { db } from "../../lib/api";
import { useSession } from "../../lib/session";
import { PageHead } from "../../components/Shell";
import { Field, Panel, useToast } from "../../components/ui";
import { setWaMode, waMode, type WaMode } from "../../lib/whatsapp";

/** Everyone can change the name the CRM shows for them. */
export default function YourProfile() {
  const { profile, refresh } = useSession();
  const toast = useToast();
  const [name, setName] = useState<string | null>(null);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const [wa, setWa] = useState<WaMode>(waMode());
  const v = name ?? profile?.display_name ?? "";
  async function save() {
    setBusy(true); setErr("");
    try {
      const r = await db.rpc<{ ok: boolean; reason?: string }>("set_display_name", { p_user: profile!.user_id, p_name: v });
      if (!r.ok) { setErr(r.reason ?? "Not saved"); return; }
      await refresh(); setName(null); toast("Name updated");
    } catch (e) { setErr((e as Error).message); } finally { setBusy(false); }
  }
  return (
    <>
      <PageHead title="Your profile" />
      <Panel title="Your name" hint="Shown in the menu, on tasks, the scoreboard and in your team's view.">
        <div className="panel-body form-grid">
          <Field label="Display name"><input className="input" value={v} maxLength={80} onChange={(e) => setName(e.target.value)} onKeyDown={(e) => e.key === "Enter" && save()} /></Field>
          <Field label="Sign-in email"><input className="input" value={profile?.email ?? ""} disabled /></Field>
          <div className="wide toolbar" style={{ margin: 0 }}>
            <button className="btn primary" disabled={busy || v.trim() === profile?.display_name} onClick={save}>{busy ? "Saving…" : "Save"}</button>
            {err && <span className="small" style={{ color: "var(--alert)" }}>{err}</span>}
          </div>
        </div>
      </Panel>
      <Panel title="WhatsApp on this device" hint="Where the WhatsApp buttons open. A website can't use a tab you opened yourself, so pick one of these.">
        <div className="panel-body stack">
          <label className="switch-row"><input type="radio" name="wa" checked={wa === "tab"} onChange={() => { setWa("tab"); setWaMode("tab"); toast("WhatsApp opens in one tab"); }} />
            <span><b>One WhatsApp Web tab</b> <span className="small muted">· opened the first time, then reused for every message</span></span></label>
          <label className="switch-row"><input type="radio" name="wa" checked={wa === "app"} onChange={() => { setWa("app"); setWaMode("app"); toast("WhatsApp opens the desktop app"); }} />
            <span><b>The WhatsApp desktop app</b> <span className="small muted">· no new tab; needs the app installed on this computer</span></span></label>
        </div>
      </Panel>
      <p className="small muted">The name on emails sent to clients ("Rahmat from Royal Compass") is set separately in Settings → Emails &amp; reminders.</p>
    </>
  );
}
